<div id="side-bar" class="hidden-sm hidden-xs" style="width: 300px">
    <div class="row-custom">
        <div class="col-xs-12">
            <h1>{{titulo}}</h1>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12">
            <div class="cover-link"></div>
            <ul class="nav nav-tabs nav-stacked wizard" role="tablist">
                <li *ngFor="let etapa of etapasAtivas; index as numero" role="presentation" [ngClass]="{'active': etapa.numero <= etapaAtual?.numero}">
                    <a aria-controls="formA" role="tab" data-toggle="tab">
                        {{etapa.descricao}}
                        <span style="padding-right: 0.5px; padding-top: 4.5px">{{numero+1}}</span>
                    </a>
                    <ul *ngIf="showSubetapas(etapa)" class="nav-stacked sub" role="tablist">
                      <li *ngFor="let sub of etapa.subetapas; index as numeroSub" role="presentation" [ngClass]="{'active': sub.numero <= etapaAtual?.numero}">
                          <a aria-controls="formA" role="tab" data-toggle="tab">
                              {{sub.descricao}}
                              <span>{{numero+1}}.{{numeroSub+1}}</span>
                          </a>
                      </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
